import { ProxyStorageAdapter } from './proxy_storage';

// === QQ/微信小程序 ===

export type WxCallback = () => void
export type WxFailCallback = (e: Error) => void
export interface WxAPI {
  getStorageInfo: (opts: {
    success: (res: { keys: string[] }) => void
    fail: WxFailCallback
  }) => void
  setStorage: (opts: {
    key: string
    data: any
    success: WxCallback
    fail: WxFailCallback
  }) => void
  getStorage: (opts: {
    key: string
    success: (res: { data: any }) => void
    fail: WxFailCallback
  }) => void
  removeStorage: (opts: {
    key: string
    success: WxCallback
    fail: WxFailCallback
  }) => void
  clearStorage: (opts: {
    success: WxCallback
    fail: WxFailCallback
  }) => void
}

export const wxStorageAdapter: ProxyStorageAdapter<WxAPI> = api => ({
  keys() {
    return new Promise((resolve, reject) => api.getStorageInfo({
      success: ({ keys }) => resolve(keys),
      fail: reject,
    }));
  },
  setItem(key: string, value?: any) {
    return new Promise((resolve, reject) => api.setStorage({
      key,
      data: value,
      success: resolve,
      fail: reject,
    }));
  },
  getItem(key: string) {
    return new Promise((resolve, reject) => api.getStorage({
      key,
      success: ({ data }) => resolve(data),
      fail: reject,
    }));
  },
  removeItem(key: string) {
    return new Promise((resolve, reject) => api.removeStorage({
      key,
      success: resolve,
      fail: reject,
    }));
  },
  clear() {
    return new Promise((resolve, reject) => api.clearStorage({
      success: resolve,
      fail: reject,
    }));
  },
});

// === Hippy ===

export interface AsyncStorage {
  getAllKeys(): Promise<string[]>;
  getItem(key: string): Promise<string>;
  multiGet(keys: string[]): Promise<string[]>;
  multiRemove(keys: string[]): Promise<void>;
  multiSet(keys: { [key: string]: string | number }): Promise<void>;
  removeItem(key: string): Promise<void>;
  setItem(key: string, value: string | number): Promise<void>;
}

export const hippyStorageAdapter: ProxyStorageAdapter<AsyncStorage> = storage => ({
  keys: storage.getAllKeys,
  async setItem(key: string, value?: any) {
    if (value === undefined) {
      await storage.removeItem(key);
      return;
    }
    await storage.setItem(key, JSON.stringify(value));
  },
  async getItem(key: string) {
    const value = await storage.getItem(key);
    return value ? JSON.parse(value) as any : undefined;
  },
  async batchSet(data: Record<string, any>) {
    const sets = Object
      .entries(data)
      .filter(([, v]) => v !== undefined);
    const dels = Object
      .entries(data)
      .filter(([, v]) => v === undefined);
    if (dels.length > 0) {
      await this.batchRemove!(dels.map(([k]) => k));
    }
    if (sets.length > 0) {
      await storage.multiSet(Object.fromEntries(sets.map(([k, v]) => [k, JSON.stringify(v)])));
    }
  },
  async batchGet(keys: string[]) {
    const values = await storage.multiGet(keys);
    return Object.fromEntries(keys
      .map((k, i) => [k, values[i] ? JSON.parse(values[i]) as any : undefined])) as any;
  },
  batchRemove: storage.multiRemove,
});
